import axios from "axios";
import API_VERSION from "../data/api-version";

const ShopifyResetPassword = async (email) => {
  try {
    const response = await axios({
      url: `https://${process.env.REACT_APP_SHOP_URL}/api/${API_VERSION}/graphql.json`,
      method: "POST",
      headers: {
        "X-Shopify-Storefront-Access-Token": process.env.REACT_APP_SHOP_ACCESS_TOKEN,
      },
      data: {
        query: `mutation {
          customerRecover(email: "${email}") {
            customerUserErrors {
              code
              field
              message
            }
          }
        }`,
      },
    });

    if (response?.data) {
      return response.data;
    } else {
      return null;
    }
  } catch (e) {
    console.log(e);
    return null;
  }
};

export default ShopifyResetPassword;
